import MemLearning from '@memrise/memlearning';
import {
  convertMemLearningTypingCardToAnswers,
  convertMemLearningTappingCardToAnswers,
} from './conversion';
import { getCorrectness } from './correctnessEvaluation/correctness';

// @ts-ignore: TO-DO - fix ignore
class CorrectnessExtender
  implements MemLearning.com.memrise.learning.session.CorrectnessExtending {
  evaluateTyping(
    userAnswer: string,
    card: MemLearning.com.memrise.learning.session.cards.TypingTestCard,
    // @ts-ignore: TO-DO - fix ignore
  ): MemLearning.com.memrise.learning.evaluation.Correctness {
    const correctAnswers = convertMemLearningTypingCardToAnswers(card);

    const { isStrict } = MemLearning.com.memrise.learning.models.TypingCardTemplate.prototype;

    const correctness = getCorrectness(
      correctAnswers,
      userAnswer,
      false,
      isStrict,
      card.isRomanized,
    );
    return MemLearning.com.memrise.foundation.makeEnum('Correctness', correctness);
  }

  evaluateTapping(
    userAnswer: string,
    card: MemLearning.com.memrise.learning.session.cards.TappingTestCard,
    // @ts-ignore: TO-DO - fix ignore
  ): MemLearning.com.memrise.learning.evaluation.Correctness {
    const correctAnswers = convertMemLearningTappingCardToAnswers(card);

    const { isStrict } = MemLearning.com.memrise.learning.models.TappingCardTemplate.prototype;

    const correctness = getCorrectness(
      correctAnswers,
      userAnswer,
      true,
      isStrict,
    );
    return MemLearning.com.memrise.foundation.makeEnum('Correctness', correctness);
  }
}

export const correctnessExtender = new CorrectnessExtender();
